<template>
  <div>
    <b-modal
      id="modal-rooms"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      title="Manage Room"
    >
      <div>
        <div v-if="roomForm">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Room Name"
                  invalid-feedback="Room Name is required"
                  ref="room_name"
                >
                  <b-form-input
                    v-model.trim="roomObj.name"
                    placeholder="Enter room name"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Capacity"
                  invalid-feedback="Capacity is required"
                  ref="room_capacity"
                >
                  <b-form-input
                    type="number"
                    v-model="roomObj.capacity"
                    placeholder="Enter room capacity"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right py-1 border-top">
              <b-button
                variant="success"
                class="mr-1"
                :disabled="savingRoom"
                @click="saveRoom(false)"
              >
                <b-spinner v-if="savingRoom" small type="grow" class="mr-75" />
                <span>Save</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                :disabled="savingRoom"
                @click="roomForm = false"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <b-button variant="primary" @click="addRoom()" class="mb-1">
            Add Room
          </b-button>

          <b-table
            sticky-header="400px"
            :items="allRooms"
            :fields="roomFields"
            responsive
            hover
            :busy="roomLoading"
            show-empty
            small
          >
            <template #table-busy>
              <div class="d-flex justify-content-center my-3">
                <b-spinner
                  style="width: 2rem; height: 2rem"
                  type="grow"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
              </div>
            </template>

            <template #cell(name)="data">
              <b-badge variant="light-primary">
                {{ data.value }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button
                variant="primary"
                class="btn-icon"
                @click="editRoom(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>

    <b-card v-if="adding">
      <b-card-title
        >Add Schedule
        <hr />
      </b-card-title>
      <b-row>
        <b-col md="6">
          <b-form-group
            label="Duration"
            invalid-feedback="Duration is required."
          >
            <div class="row">
              <b-form-group
                label=""
                invalid-feedback="From date is required."
                class="col-md-6"
                ref="dtFrom"
              >
                <flat-pickr
                  :config="config"
                  v-model="saveObj.dtFrom"
                  class="form-control"
                  placeholder="from"
                  @on-change="CheckDate()"
                />
              </b-form-group>
              <b-form-group
                label=""
                invalid-feedback="To date is required."
                class="col-md-6"
                ref="dtTo"
              >
                <flat-pickr
                  :config="
                    saveObj.dtFrom
                      ? { ...config, minDate: saveObj.dtFrom }
                      : config
                  "
                  v-model="saveObj.dtTo"
                  class="form-control"
                  placeholder="to"
                  :disabled="!saveObj.dtFrom"
                  @on-change="CheckDate()"
                />
              </b-form-group>
            </div>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group label="Extra Class">
              <b-form-checkbox inline :checked="saveObj.isExtra" />
            </b-form-group>
        </b-col> -->
        <b-col md="6">
          <b-form-group
            label="Class"
            :invalid-feedback="$t('Class is required')"
            ref="clsSec"
          >
            <v-select
              v-model="selectedEnroll"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :filterBy="dropFilter"
              :clearable="false"
              :options="enrollOptions"
              label="name"
              placeholder="Select class"
              :disabled="enLoading"
            >
              <template #option="option">
                <div>
                  {{ option.clsName }} ({{ option.secName }}) -
                  {{ option.subName }} - {{ option.name }}
                </div>
              </template>
              <template #selected-option="option">
                <div>
                  {{ option.clsName }} ({{ option.secName }}) -
                  {{ option.subName }} - {{ option.name }}
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group invalid-feedback="Room is required." ref="room">
            <template #label>
              <span>
                Room
                <feather-icon
                  class="cursor-pointer ml-50"
                  icon="EditIcon"
                  size="16"
                  v-b-tooltip.hover.top
                  title="Manage Rooms"
                  @click="openRoom()"
                />
              </span>
            </template>
            <v-select
              v-model="saveObj.roomID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="allRooms"
              :reduce="(op) => op.id"
              :clearable="false"
              :disabled="roomLoading"
              label="name"
              placeholder="select room"
            >
              <template #option="option">
                <div>
                  {{ option.name }}
                  <span class="font-weight-bold">({{ option.capacity }})</span>
                </div>
              </template>
              <template #selected-option="option">
                <div>
                  {{ option.name }}
                  <span class="font-weight-bold">({{ option.capacity }})</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col> -->
        <b-col md="6" v-if="isCoaching">
          <b-form-group
            label="Session"
            invalid-feedback="Session is required."
            ref="session"
          >
            <v-select
              v-model="saveObj.sessionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sessions"
              :reduce="(opt) => opt.id"
              label="session"
              :clearable="false"
              placeholder="Select session"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <h5>
            Timings
            <hr />
          </h5>
          <b-row v-for="(item, index) in timingInfo" :key="index">
            <b-col md="3" class="">
              <b-form-group
                label="Day"
                invalid-feedback="Day is required."
                ref="day"
              >
                <v-select
                  v-model="item.day"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="daysList"
                  :reduce="(op) => op.value"
                  :selectable="(opt) => !currDays.includes(opt.value)"
                  :clearable="false"
                  label="text"
                  placeholder="select day"
                  :disabled="disableFields"
                  @input="
                    changeDay();
                    resetRoomItem(item);
                  "
                />
              </b-form-group>
            </b-col>

            <b-col md="3" class="">
              <b-form-group
                label="Start Time"
                invalid-feedback="Start Time is required."
                ref="start"
              >
                <flat-pickr
                  v-model="item.timeIn"
                  class="form-control"
                  placeholder="Select time"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    altFormat: 'h:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d\\TH:i:S',
                    defaultHour: 8,
                  }"
                  :disabled="disableFields"
                  @on-close="resetRoomItem(item)"
                />
              </b-form-group>
            </b-col>

            <b-col md="3" class="">
              <b-form-group
                label="End Time"
                invalid-feedback="End Time is required."
                ref="end"
              >
                <flat-pickr
                  v-model="item.timeOut"
                  class="form-control"
                  placeholder="Select time"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    altFormat: 'h:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d\\TH:i:S',
                    defaultHour: 10,
                  }"
                  :disabled="disableFields"
                  @on-close="resetRoomItem(item)"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                label="Room"
                invalid-feedback="Room is required."
                ref="room"
              >
                <v-select
                  v-model="item.roomID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="item.roomList"
                  :reduce="(op) => op.id"
                  :clearable="false"
                  :disabled="
                    disableFields || itemRoomLoader || disableRoom(item)
                  "
                  label="name"
                  placeholder="select room"
                >
                  <template #option="option">
                    <div>
                      {{ option.name }}
                      <span class="font-weight-bold"
                        >({{ option.capacity }})</span
                      >
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div>
                      {{ option.name }}
                      <span class="font-weight-bold"
                        >({{ option.capacity }})</span
                      >
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>

            <b-col md="12" class="text-center" v-if="saveObj.id == 0">
              <b-button
                v-if="index == timingInfo.length - 1"
                @click="addDay()"
                variant="primary"
                class="btn-icon rounded-circle mr-50 mt-1"
              >
                <feather-icon size="18" icon="PlusIcon" />
              </b-button>
              <b-button
                v-if="timingInfo.length > 1"
                @click="removeDay(index)"
                variant="outline-danger"
                class="btn-icon rounded-circle mt-1"
              >
                <feather-icon size="18" icon="XIcon" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="12">
          <hr />
          <b-button variant="success" @click="Save()" :disabled="request">
            <b-spinner v-if="request" small type="grow" class="mr-75" />
            <span>Save</span>
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="adding = false"
            :disabled="request"
            class="ml-1"
          >
            <span>Cancel</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card v-else>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4">
          <b-button @click="AddOpen()" variant="primary" block>
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span>Schedule</span>
          </b-button>
        </b-col>
        <b-col xl="2" lg="3" md="4">
          <b-button @click="openRoom()" variant="primary" block>
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span>Rooms</span>
          </b-button>
        </b-col>
        <b-col xl="8" lg="6" md="12" class="mt-md-0 mt-1">
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                placeholder="Search by class, section, subject, teacher, day"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="searchFilters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>
        <template #top-row="data">
          <td>
            <b-form-input v-model="filterDuration" size="sm"></b-form-input>
          </td>
          <td><b-form-input v-model="filterClass" size="sm"></b-form-input></td>
          <td>
            <b-form-input v-model="filterSubject" size="sm"></b-form-input>
          </td>
          <td>
            <b-form-input v-model="filterTeacher" size="sm"></b-form-input>
          </td>
          <td><b-form-input v-model="filterDay" size="sm"></b-form-input></td>
          <td><b-form-input v-model="filterTime" size="sm"></b-form-input></td>
        </template>
        <template #cell(duration)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.obj.dtFrom).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
            -
            {{
              new Date(data.item.obj.dtTo).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(class)="data">
          <b-badge variant="light-primary">
            {{ data.item.name }} - {{ data.item.section }}
          </b-badge>
        </template>
        <template #cell(subject)="data">
          <b-badge variant="light-primary">
            {{ data.item.subject }}
          </b-badge>
        </template>
        <template #cell(teacher)="data">
          <b-badge variant="light-primary">
            {{ data.item.teacher }}
          </b-badge>
        </template>
        <template #cell(day)="data">
          <b-badge variant="light-primary" class="text-capitalize mb-25">
            {{ data.item.day }}
          </b-badge>
          <br />
          <b-badge variant="light-primary">
            {{ getRoomName(data.item.obj.roomID) }}
          </b-badge>
        </template>
        <template #cell(time)="data">
          <b-badge variant="light-primary">
            {{ data.item.startTime }} - {{ data.item.endTime }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              variant="primary"
              v-b-tooltip.hover.left
              title="Edit"
              class="btn-icon mr-50"
              @click="EditOpen(data.item.obj)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              variant="outline-danger"
              v-b-tooltip.hover.right
              title="Delete"
              class="btn-icon"
              @click="Delete(data.item.obj.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="searchFilters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  async created() {
    this.LoadData();
    this.LoadEnSelection();
    this.LoadRooms();
    if (this.isCoaching) this.LoadSessions();
  },
  computed: {
    disableFields() {
      return !this.selectedEnroll || !this.saveObj.dtFrom || !this.saveObj.dtTo;
    },
    filters: function () {
      return this.items.filter((pro) => {
        let keyword = this.searchQuery.toLowerCase();
        let clsName = pro.name.toLowerCase();
        let secName = pro.section.toLowerCase();
        let clsSecName =
          pro.name.toLowerCase() + " " + pro.section.toLowerCase();
        let subName = pro.subject.toLowerCase();
        let teacherName = pro.teacher.toLowerCase();
        let dayName = pro.day.toLowerCase();
        let roomName = this.getRoomName(pro.obj.roomID).toLowerCase();
        return (
          clsName.match(keyword) ||
          secName.match(keyword) ||
          clsSecName.match(keyword) ||
          subName.match(keyword) ||
          teacherName.match(keyword) ||
          dayName.match(keyword) ||
          roomName.match(keyword)
        );
      });
    },
    searchFilters: function () {
      return this.items.filter((pro) => {
        let clsSecName = (pro.name + " " + pro.section).toLowerCase();
        let subName = pro.subject.toLowerCase();
        let teacherName = pro.teacher.toLowerCase();
        let dayName = pro.day.toLowerCase();
        let roomName = this.getRoomName(pro.obj.roomID).toLowerCase();

        let tFrom = new Date(pro.obj.dtFrom)
          .toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
          .toLowerCase();
        let tTo = new Date(pro.obj.dtTo)
          .toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
          .toLowerCase();
        let fDuration = (tFrom + " - " + tTo).toLowerCase();
        let fTime =
          pro.startTime.toLowerCase() + " - " + pro.endTime.toLowerCase();

        return (
          fDuration.includes(this.filterDuration.toLowerCase()) &&
          clsSecName.includes(this.filterClass.toLowerCase()) &&
          subName.includes(this.filterSubject.toLowerCase()) &&
          teacherName.includes(this.filterTeacher.toLowerCase()) &&
          (dayName.includes(this.filterDay.toLowerCase()) ||
            roomName.includes(this.filterDay.toLowerCase())) &&
          fTime.includes(this.filterTime.toLowerCase())
        );
      });
    },
  },
  data() {
    return {
      isCoaching:
        this.$store.state.currentBranch.organizationType == "coaching",
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      request: false,
      daysList: [
        { text: "Monday", value: "monday" },
        { text: "Tuesday", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursday", value: "thursday" },
        { text: "Friday", value: "friday" },
        { text: "Saturday", value: "saturday" },
        { text: "Sunday", value: "sunday" },
      ],
      sidebarTitle: "Add Session",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      dataloading: false,
      logoloading: "",
      searchQuery: "",
      filterDuration: "",
      filterClass: "",
      filterSubject: "",
      filterTeacher: "",
      filterDay: "",
      filterTime: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      fields: [
        { label: "duration", key: "duration" },
        { label: "class", key: "class" },
        { label: "subject", key: "subject" },
        { label: "teacher", key: "teacher" },
        { label: "day", key: "day" },
        { label: "time", key: "time" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: null,
      timetable: {
        id: 0,
        tID: 0,
        campusID: this.$store.state.userData.cId,
        day: "",
        clsID: 0,
        section: 0,
        subID: 0,
        startTime: "",
        endTime: "",
      },
      saveObj: {
        id: 0,
        dtFrom: null,
        dtTo: null,
        isExtra: false,
        sessionID: 0,
        roomID: 0,
      },
      enLoading: false,
      enrollOptions: [],
      selectedEnroll: null,
      currDays: [],
      timingInfo: [],
      classes: [],
      classesOptions: [],
      admittedSections: [],
      subjects: [],
      adding: false,
      roomObj: {
        id: 0,
        name: "",
        type: "classroom",
        capacity: 0,
        campusID: this.$store.state.userData.cId,
      },
      allRooms: [],
      roomFields: [
        { label: "name", key: "name" },
        { label: "capacity", key: "capacity" },
        { key: "actions", label: "actions" },
      ],
      roomForm: false,
      savingRoom: false,
      roomLoading: false,
      sessions: [],
      itemRoomLoader: false,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getRoomName(id) {
      let room = this.allRooms.find((el) => el.id == id);
      return room?.name || "-";
    },
    disableRoom(el) {
      let state = false;
      if (!el.day || !el.timeIn || !el.timeOut) {
        state = true;
      } else if (el.timeIn && el.timeOut) {
        let inTime = new Date(el.timeIn).toTimeString().split(" ")[0];
        let outTime = new Date(el.timeOut).toTimeString().split(" ")[0];

        if (inTime >= outTime) state = true;
      }
      return state;
    },
    openRoom() {
      this.$bvModal.show("modal-rooms");
      this.roomForm = false;
    },
    addRoom() {
      this.roomObj = {
        id: 0,
        name: "",
        type: "classroom",
        capacity: 10,
        campusID: this.$store.state.userData.cId,
      };
      this.roomForm = true;
    },
    editRoom(item) {
      this.roomObj = { ...item };
      this.roomForm = true;
    },
    CheckName() {
      var elem = this.$refs["room_name"];
      if (!this.roomObj.name) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckCapacity() {
      var elem = this.$refs["room_capacity"];
      let x = parseInt(this.roomObj.capacity);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.roomObj.capacity = x;
        return (elem.state = true);
      }
    },
    async saveRoom() {
      const s1 = this.CheckName();
      const s2 = this.CheckCapacity();

      if (!s1 || !s2) {
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        // console.log(this.roomObj);

        this.savingRoom = true;
        let status = false;

        if (this.roomObj.id == 0) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "Rooms?db=" +
              this.$store.state.userData.db,
            body: this.roomObj,
            message: "Room added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.put({
            url:
              this.$store.state.domain +
              "Rooms/" +
              this.roomObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Room updated successfully.",
            context: this,
            body: this.roomObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingRoom = false;

        if (status) {
          this.roomForm = false;
          await this.LoadRooms();
        }
      }
    },
    resetRoomItem(el) {
      // console.log(el.timeIn, el.timeOut);
      el.roomID = 0;
      el.roomList = [];
      this.getRooms(el);
    },
    async getRooms(el) {
      const state = this.disableRoom(el);
      console.log(state);
      if (!state) {
        this.itemRoomLoader = true;
        let payload = {
          id: 0,
          tID: 0,
          campusID: this.$store.state.userData.cId,
          day: el.day,
          clsID: 0,
          section: 0,
          subID: 0,
          startTime: "",
          endTime: "",
          dtFrom: this.saveObj.dtFrom,
          dtTo: this.saveObj.dtTo,
          startTimeValue: el.timeIn,
          endTimeValue: el.timeOut,
          sessionID: this.saveObj.sessionID,
          roomID: 0,
        };
        let res = await this.post({
          url:
            this.$store.state.domain +
            "TimeTable/LoadRooms?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          subjects: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.itemRoomLoader = false;
        if (Array.isArray(res)) {
          el.roomList = res;
        }
      }
    },

    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        opt.clsName.toLowerCase().match(st) ||
        opt.secName.toLowerCase().match(st) ||
        opt.subName.toLowerCase().match(st) ||
        opt.name.toLowerCase().match(st)
      );
    },
    changeDay() {
      this.currDays = this.timingInfo.reduce((acc, el) => {
        acc.push(el.day);
        return acc;
      }, []);
      // console.log(this.currDays);
    },
    addDay() {
      this.timingInfo.push({
        id: 0,
        day: "",
        roomID: 0,
        timeIn: "",
        timeOut: "",
        roomList: [],
      });
      // console.log(this.timingInfo);
    },
    async removeDay(ind) {
      this.timingInfo.splice(ind, 1);
      this.changeDay();
    },

    EditOpen(item) {
      // console.log(item);
      this.saveObj = {
        id: item.id,
        dtFrom: item.dtFrom,
        dtTo: item.dtTo,
        sessionID: item.sessionID,
        roomID: item.roomID,
      };

      const roomItem = this.allRooms.find((el) => el.id == item.roomID);

      this.timingInfo = [
        {
          id: 0,
          day: item.day,
          roomID: item.roomID,
          timeIn: item.startTimeValue,
          timeOut: item.endTimeValue,
          roomList: roomItem ? [roomItem] : [],
        },
      ];
      this.changeDay();

      this.selectedEnroll = null;
      let enItem = this.enrollOptions.find(
        (el) =>
          el.us.cID == item.clsID &&
          el.us.section == item.section &&
          el.us.subID == item.subID &&
          el.us.tID == item.tID
      );
      if (enItem) this.selectedEnroll = enItem;

      this.adding = true;

      this.$nextTick(() => {
        var elem = this.$refs["dtFrom"];
        elem.state = undefined;
        var elem = this.$refs["dtTo"];
        elem.state = undefined;
        var elem = this.$refs["clsSec"];
        elem.state = undefined;
        if (this.isCoaching) {
          var elem = this.$refs["session"];
          elem.state = undefined;
        }
      });
    },

    AddOpen() {
      this.adding = true;

      this.saveObj = {
        id: 0,
        dtFrom: null,
        dtTo: null,
        isExtra: false,
        sessionID: 0,
        roomID: 0,
      };
      this.timingInfo = [
        {
          id: 0,
          day: "monday",
          roomID: 0,
          timeIn: "",
          timeOut: "",
          roomList: [],
        },
      ];
      this.changeDay();
      this.selectedEnroll = null;

      this.$nextTick(() => {
        var elem = this.$refs["dtFrom"];
        elem.state = undefined;
        var elem = this.$refs["dtTo"];
        elem.state = undefined;
        var elem = this.$refs["clsSec"];
        elem.state = undefined;
        if (this.isCoaching) {
          var elem = this.$refs["session"];
          elem.state = undefined;
        }
      });
    },

    CheckDate() {
      if (this.saveObj.dtFrom && this.saveObj.dtTo) {
        var elem = this.$refs["dtTo"];
        const chk = new Date(this.saveObj.dtTo) < new Date(this.saveObj.dtFrom);
        elem.state = !chk;
      } else this.saveObj.dtTo = null;
    },
    CheckDtFrom() {
      var elem = this.$refs["dtFrom"];
      if (!this.saveObj.dtFrom) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDtTo() {
      var elem = this.$refs["dtTo"];
      if (!this.saveObj.dtTo) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClass() {
      var elem = this.$refs["clsSec"];
      if (!this.selectedEnroll) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSession() {
      if (this.isCoaching) {
        var elem = this.$refs["session"];
        if (this.saveObj.sessionID == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckTimings() {
      let state = this.timingInfo.length > 0;
      this.timingInfo.forEach((el) => {
        if (!el.day || !el.timeIn || !el.timeOut || el.roomID == 0) {
          state = false;
        } else if (el.timeIn && el.timeOut) {
          let inTime = new Date(el.timeIn).toTimeString().split(" ")[0];
          let outTime = new Date(el.timeOut).toTimeString().split(" ")[0];

          if (inTime >= outTime) state = false;
        }
      });
      // console.log(state);
      return state;
    },
    async Save() {
      const s1 = this.CheckDtFrom();
      const s2 = this.CheckDtTo();
      const s3 = this.CheckClass();
      const s4 = this.CheckTimings();
      const s5 = this.CheckSession();

      if (!s1 || !s2 || !s3 || !s4 || !s5) {
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        // console.log(this.saveObj);
        let payload = this.timingInfo.map((el) => {
          return {
            id: this.saveObj.id,
            tID: this.selectedEnroll.us.tID,
            campusID: this.$store.state.userData.cId,
            day: el.day,
            clsID: this.selectedEnroll.us.cID,
            section: this.selectedEnroll.us.section,
            subID: this.selectedEnroll.us.subID,
            startTime: "",
            endTime: "",
            dtFrom: this.saveObj.dtFrom,
            dtTo: this.saveObj.dtTo,
            startTimeValue: el.timeIn,
            endTimeValue: el.timeOut,
            sessionID: this.saveObj.sessionID,
            roomID: el.roomID,
          };
        });
        // console.log(payload);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "TimeTable/SaveData?db=" +
            this.$store.state.userData.db,
          body: payload,
          message: "Schedule saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
          isTimetableConfig: true,
        });
        // console.log(status);
        if (status == true) {
          this.adding = false;
          this.LoadData();
        }
        this.request = false;
      }
    },

    async LoadSessions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);

      // console.log("Session", this.sessions);
    },
    async LoadRooms() {
      this.roomLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Rooms?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allRooms = await this.get(obj);
      this.roomLoading = false;
    },
    async LoadEnSelection() {
      this.enLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "TeacherClasses/LoadDropdown?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.enrollOptions = await this.get(obj);
      this.enLoading = false;
      // console.log(this.enrollOptions);
    },
    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "TimeTable/LoadNew?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      // console.log(this.items);
      this.dataLoading = false;
    },
    async LoadInfo() {
      this.dataloading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.classes = myitem;
      this.classesOptions = this.classes.map((el) => el.cls);

      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj);
      // console.log("sub:", this.subjects);
      this.dataloading = false;
    },
    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "TimeTable/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Schedule removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
